import { render, staticRenderFns } from "./Disbursement.vue?vue&type=template&id=2292d625&scoped=true&"
import script from "./Disbursement.vue?vue&type=script&lang=js&"
export * from "./Disbursement.vue?vue&type=script&lang=js&"
import style0 from "./Disbursement.vue?vue&type=style&index=0&id=2292d625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292d625",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnGroup,QSeparator,QTabPanels,QTabPanel,QForm,QInput,QField,QStepper} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnGroup,QSeparator,QTabPanels,QTabPanel,QForm,QInput,QField,QStepper})
